import { Config } from "../config";
// import Cookies from 'universal-cookie';
// let cookies = new Cookies();
// let access_token = cookies.get('access_token');
var sha1 = require('sha1');




// function objectToURIParams(obj) {
//     var str = "";
//     for (var key in obj) {
//         if (str === "") {
//             str = "?";
//         } else {
//             str += "&";
//         }
//         str += key + "=" + encodeURIComponent(obj[key]);
//     }
//     return str;
// }

// parse objet to uri params string
// @return string : URI formatted params
// proxy considerations added
export function objectToURIParams(obj) {
    var str = "";
    for (var key in obj) {
        str += "&";
        str += key + "=" + encodeURIComponent(obj[key]);
    }
    return str;
}

  
export async function userLoginFetch(params) {
    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = Config.language;
    params.version = Config.version;
    params.app = Config.app;

    // hash pwd
    let hashedPwd = sha1('userloginregister' + params.password);
    params.password = hashedPwd;


    let url = Config.hostUrl + 'users/login' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        });
        return response.json();
    }
    catch (e) {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
            return null;
        }
    }
}

// get user info
export function userFetch(access_token, params) {
    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = Config.language;
    params.version = Config.version;
    params.app = Config.app;

    let url = Config.hostUrl + 'users/info' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
        url,
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token
            },
            body: JSON.stringify(params),
        }
    )
        .then((response) => { return response.json(); })
        .catch(e => {
            if (e.message.indexOf("Network request failed") >= 0) {
                return null;
            }
        });
}


// LOGOUT
export function userLogoutFetch(access_token, params) {
    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = Config.language;
    params.version = Config.version;
    params.app = Config.app;
    let url = Config.hostUrl + 'users/logout' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
        url,
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token
            },
            body: JSON.stringify(params),
        }
    )
        .then((response) => {
            return response.json();
        })
        .catch(e => {
            console.log(e);
            if (e.message.indexOf("Network request failed") >= 0) {
                return null;
            }
        });

}

// GET CARDS (SKIERS)
// @return object : response
export function getCardsFetch(access_token, params) {
    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = Config.language;
    params.version = Config.version;
    params.app = Config.app;
    let url = Config.hostUrl + 'service/getCards' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
        url,
        {
            method: 'GET',

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token
            },

        }
    )
        .then((response) => {
            return response.json();
        })
        .catch(e => {
            console.log(e);
            if (e.message.indexOf("Network request failed") >= 0) {
                return null;
            }
        });

}


export function getCreditCardInfo(access_token, params) {
    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = Config.language;
    params.version = Config.version;
    params.app = Config.app;
    let url = Config.hostUrl + 'payment/getCreditCardInfo' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    return fetch(
        url,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
        }
    )
        .then((response) => response.json())
        .catch(e => {
            if (e.message.indexOf("Network request failed") >= 0) {
                return null;
            }
        });
}

export function checkForPromo(access_token, params) {
    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = Config.language;
    params.version = Config.version;
    params.app = Config.app;
    let url = Config.hostUrl + 'service/checkForPromo' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    return fetch(
        url,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
        }
    )
        .then((response) => response.json())
        .catch(e => {
            if (e.message.indexOf("Network request failed") >= 0) {
                return null;
            }
        });
}


export async function buyPromoTicket(access_token, params) {
    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = Config.language;
    params.version = Config.version;
    params.app = Config.app;

    let url = Config.hostUrl + 'service/buyPromoTicket' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            body: JSON.stringify(params),
        });
        return response.json();
    }
    catch (e) {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
            return null;
        }
    }
}
